import Modal from "antd/es/modal/Modal";
import React, { useEffect, useState } from "react";
import { Button } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import styles from "css/mobile/mypage.module.css";

export default function ResComfirmPop({
  isOpenResConfirm,
  close,
  newSchedule,
  setNewSchedule,
}) {
  const payload = useSelector((state) => state.user);
  const { t, i18n } = useTranslation();
  const [currentSchedule, setCurrentSchedule] = useState(newSchedule);

  useEffect(() => {
    setCurrentSchedule(newSchedule);
  }, [isOpenResConfirm]);

  const closePop = () => {
    setNewSchedule({});
    close();
  };
  const datetimeConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("MMMM D, YYYY (ddd) - hh:mm A");
    } else {
      return moment(value).locale("ko").format("YYYY-MM-DD (dd) - a hh:mm");
    }
  };

  return (
    <>
      <Modal
        className={styles.resConfirmPop}
        open={isOpenResConfirm}
        onCancel={closePop}
        maskClosable={false}
        footer={null}
        closable={false}
      >
        <div className={styles.resConfirmPopContanier}>
          <div className={styles.resConfirmPopHeader}>
            <img
              src={
                process.env.REACT_APP_CLIENT_URL +
                "img/mobile/mypage/meeting_confirm.png"
              }
              alt="meeting_confirm"
            />
            <div className={styles.resConfirmPopHeaderTitle}>
              {t("MESSAGE.MEETING_CONFIRM")}
            </div>
          </div>
          <div className={styles.resConfirmPopContent}>
            <div className={styles.resConfirmPopContent_item}>
              <div className={styles.resConfirmPopContent_label}>
                {t("LABEL.MEETING_TITLE")}
              </div>
              <div className={styles.resConfirmPopContent_value}>
                {currentSchedule.TITLE}
              </div>
            </div>

            <div className={styles.resConfirmPopContent_dateArea}>
              <div className={styles.resConfirmPopContent_startArea}>
                <div className={styles.resConfirmPopContent_label}>
                  {t("LABEL.MEETING_START")}
                </div>
                <div className={styles.resConfirmPopContent_value}>
                  {datetimeConverter(currentSchedule.START_TIME)}
                </div>
              </div>
              <div className={styles.resConfirmPopContent_endArea}>
                <div className={styles.resConfirmPopContent_label}>
                  {t("LABEL.MEETING_END")}
                </div>
                <div className={styles.resConfirmPopContent_value}>
                  {datetimeConverter(currentSchedule.END_TIME)}
                </div>
              </div>
            </div>

            <div className={styles.resConfirmPopContent_item}>
              <div className={styles.resConfirmPopContent_label}>
                {t("LABEL.MEETING_HOST")}
              </div>
              <div className={styles.resConfirmPopContent_value}>
                {payload.name}
              </div>
            </div>

            <div className={styles.resConfirmPopContent_item}>
              <div className={styles.resConfirmPopContent_label}>
                {t("LABEL.MEETING_PLACE")}
              </div>
              <div className={styles.resConfirmPopContent_endpointValue}>
                {currentSchedule.ENDPOINT_LIST?.length > 0 ? (
                  currentSchedule.ENDPOINT_LIST.map(
                    (endpoint) => endpoint.ENDPOINT_NM
                  ).join(", ")
                ) : (
                  <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                )}
              </div>
            </div>

            <div className={styles.resConfirmPopContent_item}>
              <div className={styles.resConfirmPopContent_label}>
                {t("LABEL.MEETING_PTCP")}
              </div>
              <div className={styles.resConfirmPopContent_participantValue}>
                {currentSchedule.PARTICIPANT_LIST?.length > 0 ? (
                  currentSchedule.PARTICIPANT_LIST.map((participant, index) => (
                    <div key={index}>
                      {participant.MEMBER_NM} <p />[{participant.EMAIL}]
                    </div>
                  ))
                ) : (
                  <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                )}
              </div>
            </div>

            {currentSchedule.ATTACHMENT_LIST?.length > 0 && (
              <div className={styles.resConfirmPopContent_item}>
                <div className={styles.resConfirmPopContent_label}>
                  {t("LABEL.ATTACHMENT")}
                </div>
                <div className={styles.resConfirmPopContent_value}>
                  {currentSchedule.ATTACHMENT_LIST.map((attachment, index) => (
                    <div key={index}>{attachment.ORI_FILE_NM}</div>
                  ))}
                </div>
              </div>
            )}
            {currentSchedule.CONTENTS && (
              <div className={styles.resConfirmPopContent_item}>
                <div className={styles.resConfirmPopContent_label}>
                  {t("LABEL.MEETING_CONTENT")}
                </div>
                <div
                  className={styles.resConfirmPopContent_value}
                  style={{ maxWidth: "calc(100% - 70px)" }}
                >
                  {currentSchedule.CONTENTS}
                </div>
              </div>
            )}
          </div>
          <div className={styles.resConfirmPopFooter}>
            <Button
              type="primary"
              onClick={() => closePop()}
              className={styles.resConfirmPopFooter_button}
            >
              {t("BTN.OK")}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
